import React, { useEffect, useRef, useState } from "react";
import Sidebaar from "../Component/Sidebar";
import TitleComp from "../Component/TitleComp";
import { Button, Col, Form, FormGroup, Modal } from "react-bootstrap";
import axios from "axios";
import { Base_Url } from "../BaseUrl";
import Select from "react-select";
import { Bars } from "react-loader-spinner";
import { DataGrid } from "@mui/x-data-grid";
import { Box } from "@mui/material";
import { ToastContainer, toast } from "react-toastify";
import { compressImage } from "../Component/CompressImage";

function Frames() {
  const [name, setname] = useState("");
  const [file, setfile] = useState("");
  const [loading, setloading] = useState(false);
  const [width, setwidth] = useState("")
  const [height, setheight] = useState("")
  let previousdata = []
  const [idindex, setidindex] = useState("");
  const [framedata, setframedata] = useState([]);
  const [brand, setbrand] = useState([]);
  const [editimg, seteditimg] = useState("");
  const [brandmodelsdata, setbrandmodeldata] = useState([]);
  const [activeBrand, setActiveBrand] = useState([]);
  const [id, setid] = useState("");
  const [catdata, setCatdata] = useState([]);
  const [datalength, setdatalength] = useState("")
  const [selectedCatOptions, setSelectedCatOptions] = useState([]);
  const [selectshowbrand, setselectshowbrand] = useState([]);
  const [brandfilterdata, setbrandfilterdata] = useState([]);


  const ImageInputRef = useRef(null);

  const PltInputRef = useRef(null);

  const [search, setsearch] = useState("")

  const [selectbrandfilter, setselectbrandfilter] = useState([])

  const [framecat, setframecat] = useState([]);
  const [filteredCategories, setFilteredCategories] = useState([]);
  let token = localStorage.getItem("token");
  const [plt, setplt] = useState("");
  const [disablebtn, setdisablebtn] = useState(false)
  const [cat, setcat] = useState([])
  const headers = {
    Authorization: `Bearer ${token}`,
  };




  const Catoptions = cat.map((item) => ({
    value: item._id,
    label: item.name,
  }));

  const handleselectcat = (selectedValues) => {
    setSelectedCatOptions(selectedValues);
  };

  const handleselectbrand = (selectedValues) => {
    setselectshowbrand(selectedValues);
  };



  const [imageurl, setimageurl] = useState("")


  const [show, setShow] = useState(false);
  const [page, setpage] = useState(0)

  const handleClose = () => setShow(false);
  const handleShow = (e, value) => {
    setShow(true)
    setimageurl(value)
  };

  const handleframeget = () => {
    setloading(true)
    axios.get(`${Base_Url}/frames?page=${0}`, { headers }).then((res) => {
      setframedata(res.data.data)

    }).finally(() => {
      setloading(false)
    })
  };


  const categoriesget = () => {
    axios.get(`${Base_Url}/categories`, { headers }).then((res) => {
      // console.log(res.data.data);
      setcat(res.data.data);
    });
  };

  useEffect(() => {
    categoriesget()
  }, [])


  const handleprevious = (previous) => {
    if (selectbrandfilter != "") {
      setloading(true)
      axios.get(`${Base_Url}/frames?brand=${selectbrandfilter.value}&page=${previous - 1}`, { headers })
        .then((res) => {


          if (res.data && res.data.data.length == 10) {


            const newData = [...framedata];
            newData.splice(-datalength);
            setframedata(newData);

            console.log("data leng", newData)



            // setframedata( res.data.data);

            setdisablebtn(false)
          } else {
            setdisablebtn(true)
          }
        })
        .catch((error) => {
          // Handle any errors that occur during the request
          console.error("Error fetching data:", error);
        }).finally(() => {
          setloading(false)
        })
    } else {
      setloading(true)
      axios.get(`${Base_Url}/frames?page=${previous - 1}`, { headers })
        .then((res) => {

          console.log("resss", res.data)


          if (res.data && res.data.data.length == 10) {

            // setframedata(res.data.data);
            const newData = [...framedata];
            newData.splice(-datalength);
            setframedata(newData);
            setdisablebtn(false)
          } else {
            setdisablebtn(true)
          }
        })
        .catch((error) => {

          console.error("Error fetching data:", error);
        }).finally(() => {
          setloading(false)
        })
    }



  };





  const handlenext = (next) => {
    setloading(true)
    if (selectbrandfilter != "") {
      axios.get(`${Base_Url}/frames?brand=${selectbrandfilter.value}&page=${next + 1}`, { headers })
        .then((res) => {
          console.log("resss", res.data)


          const newData = [...framedata, ...res.data.data];
          setdatalength(res.data.data.length)
          // setPreviousData(newData);
          setframedata(newData);
          console.log("newdata", newData)
          if (res.data && res.data.data.length == 10) {
            // If there is data in the response
            setdisablebtn(false)
          } else {
            setdisablebtn(true)
          }
        })
        .catch((error) => {
          // Handle any errors that occur during the request
          console.error("Error fetching data:", error);
        }).finally(() => {
          setloading(false)
        })
    } else {
      axios.get(`${Base_Url}/frames?page=${next + 1}`, { headers })
        .then((res) => {
          console.log("resss", res.data)
          // setframedata(res.data.data);
          const newData = [...framedata, ...res.data.data];
          // setPreviousData(newData);
          setdatalength(res.data.data.length)
          setframedata(newData);
          console.log("newdata", newData)
          if (res.data && res.data.data.length == 10) {
            // If there is data in the response
            setdisablebtn(false)
          } else {
            setdisablebtn(true)
          }
        })
        .catch((error) => {
          // Handle any errors that occur during the request
          console.error("Error fetching data:", error);
        }).finally(() => {
          setloading(false)
        })
    }



  };










  const handleedit = (e, id) => {
    e.preventDefault();
    let filterdata = search.length > 0 ? filteredCategories.filter((item) => item?._id === id) : framedata.filter((item) => item?._id === id)

    console.log("filter ", filterdata)
    filterdata = filterdata[0]
    setid(filterdata?._id);
    setname(filterdata?.name);
    seteditimg(filterdata?.image);
    setwidth(filterdata?.width)
    setheight(filterdata?.height)

    // setplt(filterdata.plt);

    setselectbrandoption({
      value: filterdata?.brand_model?._id,
      label: filterdata?.brand_model?.name,
    });

    setselectshowbrand({
      value: filterdata?.brand_model?.brand?._id,
      label: filterdata?.brand_model?.brand?.name,
    });


    setSelectedCatOptions({
      value: filterdata?.brand_model?.brand?.category?._id,
      // label: filterdata?.brand_model?.brand?.category?.name,
    });

    const selectcategory = filterdata?.brand_model?.brand?.category.map((cat) => ({
      value: cat?._id,
      label: cat?.name,
    }));

    setSelectedCatOptions(selectcategory)






    const selectframecate = filterdata?.frame_category.map((cat) => ({
      value: cat?._id,
      label: cat?.name,
    }));
    setSelectedOptions(selectframecate);
  };



  const handleframecatdata = () => {
    axios.get(`${Base_Url}/frame_categories`, { headers }).then((res) => {
      // console.log(res.data);
      setframecat(res.data.data);
    });
  };

  useEffect(() => {
    handleframecatdata();
    handleframeget();
    branddata();
    brandfitlerdata()
  }, []);

  const getRowId = (row) => row._id;
  const columns = [
    { field: "name", headerName: "Name", flex: 1 },
    {
      field: "brand_model",
      headerName: "Brand Model Name",
      flex: 1,
      valueGetter: (params) => {
        return params.row?.brand_model?.name;
      },
    },
    {
      field: "brand",
      headerName: "Brand Name",
      flex: 1,
      valueGetter: (params) => {
        return params.row?.brand_model?.brand?.name;
      },
    },
    {
      field: "image",
      headerName: "image",
      flex: 1,
      renderCell: (params) => {
        const { value } = params;
        return (
          <img
            onClick={(e) => handleShow(e, value)}
            src={`${Base_Url}/${value}`}
            style={{
              width: "45px",
              height: "45px",
              borderRadius: "50%",
            }}
            className="img-fluid tableimgmui"
          ></img>
        );
      },
    },

    {
      field: "edit",
      headerName: "Edit",
      flex: 1,
      renderCell: (params) => {
        const index = params.row.index;
        const id = params.row._id // Corrected to rowIndex
        return (
          <span
            style={{ cursor: "pointer" }}
            onClick={(e) => handleedit(e, id)}
          >
            <i className="fa-solid fa-pen-to-square"></i>
          </span>
        );
      },
    },

    {
      field: "delete",
      headerName: "Delete",
      flex: 1,
      renderCell: (params) => {
        const index = params.row.index;
        const id = params.row._id; // Corrected to rowIndex
        return (
          <span
            style={{ cursor: "pointer" }}
            onClick={(e) => {
              handleDelete(e, id);

            }}
          >
            <i class="fa-solid fa-trash"></i>
          </span>
        );
      },
    },
  ];

  const options = framecat.map((item) => ({
    value: item._id,
    label: item.name,
  }));

  const brandoption = brandmodelsdata.map((item) => ({
    value: item._id,
    label: item.name,
  }));

  const brandfilteroption = brand.map((item) => ({
    value: item._id,
    label: item.name,
  }));
  const brandcheckoption = brandfilterdata.map((item) => ({
    value: item._id,
    label: item.name,
  }));

  const [selectedOptions, setSelectedOptions] = useState([]);
  const [selectbrandoption, setselectbrandoption] = useState([]);


  console.log(selectbrandoption)

  const handleSelectChange = (selectedValues) => {
    setSelectedOptions(selectedValues);
  };

  const handleFile = (e) => {
    const selectedfile = e.target.files[[0]];
    // console.log(selectedfile);
    setfile(selectedfile);
  };

  const handleplt = (e) => {
    const selectedfile = e.target.files[[0]];
    // console.log(selectedfile);
    setplt(selectedfile);
  };

  const handlebrandselect = (selectedValues) => {
    setselectbrandoption(selectedValues);
  };

  const handlebrandfilter = (selectedValues) => {
    setselectbrandfilter(selectedValues);

    console.log("selected ", selectedValues)
    handlebrandfilterget(selectedValues.value)
    setpage(0)

  };



  const handlebrandfilterget = (id) => {
    axios.get(`${Base_Url}/frames?brand=${id}&page=${0}`, { headers }).then((res) => {
      setframedata(res.data.data)
      if (res.data.data.length > 0) {
        setdisablebtn(false)
      } else {
        setdisablebtn(true)
      }
    })
  }





  // const handleSubmit = (e) => {
  //   setloading(true);
  //   e.preventDefault();
  //   let formdata = new FormData();
  //   formdata.append("name", name);
  //   formdata.append("width" , width)
  //   formdata.append("height" , height)
  //   if (file) {
  //     formdata.append("image", file);
  //   }
  //   selectedOptions.map((option, index) => {
  //     formdata.append(`frame_category[${index}]`, option.value);
  //   });
  //   if (plt) {
  //     formdata.append("plt", plt);
  //   }
  //   formdata.append("brand_model", selectbrandoption.value);
  //   if (id) {
  //     formdata.append("_id", id);
  //     axios.put(`${Base_Url}/frames`, formdata, { headers }).then((res) => {
  //       // console.log(res);
  //       if (res.data !== null) {
  //         setloading(false);
  //         handleframeget();
  //       }
  //     });
  //   } else {
  //     axios.post(`${Base_Url}/frames`, formdata, { headers }).then((res) => {
  //       // console.log(res);
  //       if (res.data !== null) {
  //         setloading(false);
  //         handleframeget();
  //       }
  //     });
  //   }
  // };

  const handleclear = () => {
    setname("")
    setSelectedOptions([])
    setid(null)
    setselectbrandoption([])
    setwidth("")
    setheight("")
    seteditimg(null)
    if (ImageInputRef.current) {
      ImageInputRef.current.value = '';
    }
    if (PltInputRef.current) {
      PltInputRef.current.value = '';
    }
  }


  const handleSubmit = (e) => {
    setloading(true);
    e.preventDefault();
    let formdata = new FormData();
    formdata.append("name", name);
    formdata.append("width", width);
    formdata.append("height", height);
    // if (file) {
    //   compressImage(file).then((compressedFile) => {
    //     formdata.append("image", compressedFile);
    //   });
    // }
    if (file) {
      formdata.append("image", file)
    }

    selectedOptions.map((option, index) => {
      formdata.append(`frame_category[${index}]`, option.value);
    });

    if (plt) {
      formdata.append("plt", plt);
    }
    formdata.append("brand_model", selectbrandoption.value);

    if (id) {
      formdata.append("_id", id);

      axios.put(`${Base_Url}/frames`, formdata, { headers }).then((res) => {
        if (res.data !== null) {
          setloading(false);
          handlerefresh();
          handleclear()
        }
      });
    } else {
      axios.post(`${Base_Url}/frames`, formdata, { headers }).then((res) => {
        if (res.data !== null) {
          setloading(false);
          handlerefresh();
          handleclear()
        }
      });
    }
  };




  useEffect(() => {
    branddata()
    brandfitlerdata()
  }, [selectedCatOptions, selectshowbrand])




  const handlefilter = (e, selectedBrand) => {
    e.preventDefault();
    setActiveBrand(selectedBrand);

    // Filter categories based on selected brand's category IDs
    const filteredData = framedata.filter((category) => {
      if (Array.isArray(category.frame_category)) {
        return category.frame_category.some(
          (cat) => cat._id === selectedBrand._id
        );
      } else {
        return category.frame_category === selectedBrand._id;
      }
    });

    setFilteredCategories(filteredData);
  };

  useEffect(() => {
    if (framedata) {
      setFilteredCategories(framedata);
    }
  }, [framedata]);




  const branddata = () => {
    axios.get(`${Base_Url}/brand_models`, { headers }).then((res) => {
      setbrandmodeldata(res.data.data);
      if (selectshowbrand != "") {
        let filterdata = res.data.data.filter((item) => item.brand._id == selectshowbrand.value)
        setbrandmodeldata(filterdata)
      }
    });
  };

  const brandfitlerdata = () => {
    axios.get(`${Base_Url}/brands`, { headers }).then((res) => {
      setbrand(res.data.data);
      setbrandfilterdata(res.data.data)
      if (selectedCatOptions != "") {
        let filterdata = brand.filter((item) => item.category?.[0]?._id == selectedCatOptions.value)
        setbrandfilterdata(filterdata)

      }

      setselectbrandfilter({
        label: res.data.data[0].name,
        value: res.data.data[0]._id
      })
    });
  };

  const notify = (message, type) => {
    // console.log("type", type);
    toast[type](message, {
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const clearall = (e) => {
    e.preventDefault()

    setselectbrandfilter({
      label: brand[0].name,
      value: brand[0]._id
    })
    handleframeget()
    setpage(0)
    setsearch("")


    if (framedata.length >= 10) {
      setdisablebtn(false)
    } else {
      setdisablebtn(true)
    }

  }



  const handleDelete = (e, id) => {
    e.preventDefault();

    let requestdata = {
      _id: id,
      deleted_at: Math.floor(Date.now() / 1000),
    };

    axios
      .put(`${Base_Url}/frames`, requestdata, { headers })
      .then((res) => {
        // console.log(res);
        if (res.data.message === "Ok") {
          // handleframeget()
          handlerefresh()
          notify("Delete Successfully", "success");
          // console.log("Data", res.data);
        }
      })
      .catch((error) => {
        console.error("Error deleting:", error);
        notify("Error deleting", "error");
      });
  };

  const handlerefresh = () => {
    axios.get(`${Base_Url}/frames?brand=${selectbrandfilter.value}&page=${page}`, { headers }).then((res) => {
      setframedata(res.data.data)
    })
  }
  // useEffect(()=>{
  //   if(brandfilteroption){
  //     setselectbrandfilter(brandfilteroption?.[0])
  //   console.log("hellooooodf" ,brandfilteroption?.[0])
  //   }
  // },[])

  const handleSearch = (e) => {
    e.preventDefault()
    // let maindata = []
    // maindata = filteredCategories
    // console.log(maindata)
    setloading(true)
    const timeout = 300; // Set timeout to 500 milliseconds



    axios.get(`${Base_Url}/frames?query_string=${search}`, { headers }).then((res) => {
      if (res.data.error == "0") {
        setFilteredCategories(res.data.data)

      }
    }).finally(() => {
      setloading(false)
    })


  };






  return (
    <>
      {loading && (
        <div className="overlay">
          <Bars
            height="80"
            width="80"
            color="#051322"
            ariaLabel="bars-loading"
            visible={true}
          />
        </div>
      )}
      <Sidebaar
        content={
          <>
            <TitleComp title="Frames" />
            <Form onSubmit={(e) => handleSubmit(e)}>
              <div className="row gy-3 mt-3 align-items-center">
                <div className="col-md-4">
                  <FormGroup>
                    <label htmlFor="">Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={name}
                      onChange={(e) => setname(e.target.value)}
                    />
                  </FormGroup>
                </div>
                {editimg && (
                  <Col md="1">
                    <div className="m-3 mt-4">
                      <img
                        src={`${Base_Url}/${editimg}`}
                        className="img-fluid"
                        style={{ width: "40px" }}
                        alt=""
                      />
                    </div>
                  </Col>
                )}
                <Col md={editimg ? "3" : "4"}>
                  <FormGroup>
                    <label htmlFor="">Image </label>
                    <input
                      type="file"
                      ref={ImageInputRef}
                      onChange={(e) => handleFile(e)}
                      className="form-control"
                    />
                  </FormGroup>
                </Col>
                <div className="col-md-4">
                  <label htmlFor="">Frame Category</label>
                  <Select
                    options={options}
                    isMulti
                    placeholder="Search Frame Category or Select"
                    isSearchable
                    value={selectedOptions}
                    onChange={handleSelectChange}
                  />
                </div>
                <Col md='4'>
                  <label htmlFor="">Select Category</label>
                  <Select
                    options={Catoptions}
                    value={selectedCatOptions}
                    onChange={handleselectcat}
                  />
                </Col>
                <Col md='4'>
                  <label htmlFor="">Select Brand</label>
                  <Select
                    options={brandcheckoption}
                    value={selectshowbrand}
                    onChange={handleselectbrand}
                  />
                </Col>
                <div className="col-md-4">
                  <label htmlFor="">Brand Model</label>
                  <Select
                    isSearchable
                    placeholder="Search  Brand Model or Select"
                    options={brandoption}
                    value={selectbrandoption}
                    onChange={handlebrandselect}
                  />
                </div>


                {!id ? <div className="col-md-4">
                  <FormGroup>
                    <label htmlFor="">
                      Plt File{" "}
                      {id ? "" : <span className="text-danger">*</span>}
                    </label>
                    <input
                      type="file"
                      ref={PltInputRef}
                      required={id ? false : true}
                      accept=".plt"
                      onChange={(e) => handleplt(e)}
                      className="form-control"
                    />
                  </FormGroup>
                </div> : ""}
                <div className="col-md-4">
                  <FormGroup>
                    <label htmlFor="">Width</label>
                    <input
                      type="text"
                      className="form-control"
                      value={width}
                      onChange={(e) => setwidth(e.target.value)}
                    />
                  </FormGroup>
                </div>
                <div className="col-md-4">
                  <FormGroup>
                    <label htmlFor="">Height</label>
                    <input
                      type="text"
                      className="form-control"
                      value={height}
                      onChange={(e) => setheight(e.target.value)}
                    />
                  </FormGroup>
                </div>
                <div className="col-md-12">
                  <div className="">
                    <button className="btn bg-dark text-white">Submit</button>
                  </div>
                </div>
                {/* <div className="col-md-12">
                  <h2 className="mt-3 mb-1" style={{ fontSize: "22px" }}>
                    Frame Category
                  </h2>
                </div> */}



              </div>



            </Form>
            <div className="row mt-3 gy-3 align-items-center">
              <div className="col-md-10">
                <div className="d-flex gap-3 overflowscroll">
                  {framecat.map((item) => {
                    return (
                      <>
                        <button
                          key={item._id}
                          className={`btn px-5 rounded-pill ${activeBrand && activeBrand._id === item._id
                            ? " bgblackgrd text-white"
                            : "bgbluegrd text-white"
                            }`}
                          onClick={(e) => handlefilter(e, item)}
                        >
                          {item.name}
                        </button>
                      </>
                    );
                  })}
                </div>
              </div>

              <div className="col-md-2">
                <div className="text-end">
                  <button
                    className="btn bg-dark text-white"
                    onClick={(e) => {
                      setFilteredCategories(framedata);
                      setActiveBrand(null);
                      setsearch("")
                    }}
                  >
                    Show All
                  </button>
                </div>
              </div>
              <div className="row align-items-center justify-content-between">


                <div className="col-md-4">
                  <label htmlFor="">Brand</label>
                  <Select
                    isSearchable
                    placeholder="Search  Brand Model or Select"
                    options={brandfilteroption}
                    value={selectbrandfilter}
                    onChange={handlebrandfilter}
                  />
                </div>
                <div className="col-md-4">
                  <Form onSubmit={(e) => handleSearch(e)}>
                    <div className="input-group mt-4">
                      <input type="search" placeholder="Search Frames" value={search} onChange={(e) => setsearch(e.target.value)} className="form-control shadow-none" />
                      <button className="btn bg-primary text-white"><i class="fa-solid fa-magnifying-glass"></i></button>
                    </div>
                  </Form>
                </div>
                <div className="col-md-4">
                  <div className="text-end d-flex align-items-center gap-2 mb-3 justify-content-end" style={{ marginTop: "30px" }}>
                    <button className="btn bg-primary text-white" disabled={page == 0 ? true : false} onClick={(e) => { setpage(page - 1); handleprevious(page) }}><i class="fa-solid fa-angle-left"></i></button>
                    <span>{page + 1}</span>
                    <button className="btn bg-primary text-white" disabled={disablebtn} onClick={(e) => { setpage(page + 1); handlenext(page) }} ><i class="fa-solid fa-chevron-right"></i></button>
                    <div className=""><button className="btn bg-dark text-white " onClick={(e) => clearall(e)}>Clear all </button></div>
                  </div>
                </div>


              </div>
              <Col md="12">


                <Box sx={{ width: "100%" }}>
                  <DataGrid
                    // rows={filteredCategories.map((row, index) => ({
                    //   ...row,
                    //   index,
                    // }))}
                    rows={filteredCategories
                      .map((row, index) => ({
                        ...row,
                        index,
                      }))
                      ?.reverse()}
                    columns={columns}
                    // pageSize={5}
                    getRowId={getRowId}
                    pagination={false}
                  />


                </Box>

              </Col>

            </div>

            <ToastContainer />

            <Modal show={show} size="md" onHide={handleClose}>
              <Modal.Header closeButton>
                <Modal.Title>Image</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <img src={`${Base_Url}/${imageurl}`} alt="" />
              </Modal.Body>
              <Modal.Footer>
                <Button className="text-write bg-secondary  shadow-none border-0" onClick={handleClose}>
                  Close
                </Button>
              </Modal.Footer>
            </Modal>
          </>
        }
      />
    </>
  );
}

export default Frames;














